// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"JR-z","inlineTitle":"KR-z","sponsoredAdsWrapper":"LR-z","marketplaceRecosWrapper":"MR-z"};